import { render, staticRenderFns } from "./RefillUsdc.vue?vue&type=template&id=081f1440&scoped=true&"
import script from "./RefillUsdc.vue?vue&type=script&lang=js&"
export * from "./RefillUsdc.vue?vue&type=script&lang=js&"
import style0 from "./RefillUsdc.vue?vue&type=style&index=0&id=081f1440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f1440",
  null
  
)

export default component.exports